import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API
const defaultLocations = [
  {
    id: 'default-miami',
    predictionPlace: {
      address: 'Miami, FL, USA',
      bounds: new LatLngBounds(new LatLng(25.9559, -80.1171), new LatLng(25.709, -80.3164)),
    },
  },
  {
    id: 'default-new-york',
    predictionPlace: {
      address: 'New York, NY, USA',
      bounds: new LatLngBounds(new LatLng(40.9176, -73.7004), new LatLng(40.4774, -74.2591)),
    },
  },
  {
    id: 'default-los-angeles',
    predictionPlace: {
      address: 'Los Angeles, CA, USA',
      bounds: new LatLngBounds(new LatLng(34.3373, -118.1553), new LatLng(33.7037, -118.6682)),
    },
  },
  {
    id: 'default-chicago',
    predictionPlace: {
      address: 'Chicago, IL, USA',
      bounds: new LatLngBounds(new LatLng(42.0231, -87.5237), new LatLng(41.6443, -87.9402)),
    },
  },
];
export default defaultLocations;
